import './file-upload-input.scss';
import template from './file-upload-input.vhtml';

export default {
	template,
	data: () => ({
		file: null,
	}),
	props: {
		accept: {
			type: String,
			default: '',
		},
		inputName: {
			type: String,
			default: 'files[]',
		},
		translateStrings: {
			type: Object,
			default: () => ({
				addFile: 'Tilføj fil',
				remove:  'Fjern',
			}),
		},
	},
	computed: {
		filename() {
			return this.file ? appleLikeFilenameCutoff( 14, this.file.name ) : '';
		},
		showRemove() {
			return this.hasFile;
		},
		hasFile() {
			return this.file;
		},
	},
	methods: {
		onFileChanged( e ) {
			if ( e.srcElement.files && e.srcElement.files[ 0 ]) {
				this.file = e.srcElement.files[ 0 ];
				this.$emit( 'file-changed', this.file );
			}
		},
		onRemove() {
			this.$emit( 'file-removed', this.file );
		},
	},
};


/**
 * Cut off a filename Apple Finder style
 * ie. mylong...name.pdf
 *
 * @param {number} [length=12]
 * @param {string} filename
 * @returns {string}
 */
function appleLikeFilenameCutoff( length = 12, filename ) {
	length = length + 1;
	const split = filename.split( '.' );
	const type = split.slice( -1 );
	let name = split.slice( 0, -1 ).join( '.' );
	if ( name.length + type.length + 5 > length ) {
		const segmentLength = ( length - type.length - 1 ) / 2 - 2;
		name = `${name.slice( 0, Math.ceil( segmentLength ) )}…${name.slice( -1 * Math.floor( segmentLength ) )}`;
	}
	return `${name}.${type}`;
}




// WEBPACK FOOTER //
// ./assets/_js/components/file-upload-input/file-upload-input.js